import { useRef, useState } from 'react'
import { useUnreadNotifications } from '../lib/useUnreadNotifications'
import Icon from './components/Icon'
import NotificationDropdown from './NotificationDropdown'

// Top-bar notification bell with a live unread badge (architecture §6.6). Shared
// across the operator and portal shells. Clicking opens a dropdown panel
// (mockup `.noti`) with the recent notifications; "View all" → the surface's
// notification center (`href`). The badge updates over Cable.
export default function NotificationBell({
  href,
  initialUnread,
}: {
  href: string
  initialUnread: number
}) {
  const unread = useUnreadNotifications(initialUnread)
  const [open, setOpen] = useState(false)
  const btnRef = useRef<HTMLButtonElement>(null)

  return (
    <>
      <button
        ref={btnRef}
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-label="Notifications"
        aria-expanded={open}
        className="relative grid h-9 w-9 place-items-center rounded-[10px] border border-transparent text-ink-2 hover:border-border hover:bg-surface-3 hover:text-ink"
      >
        <Icon name="bell" size={18} />
        {unread > 0 && (
          <span className="absolute -right-1 -top-1 min-w-4 rounded-full bg-accent px-1 text-center text-[10px] font-semibold leading-4 text-accent-ink">
            {unread > 99 ? '99+' : unread}
          </span>
        )}
      </button>
      <NotificationDropdown
        anchorRef={btnRef}
        open={open}
        onClose={() => setOpen(false)}
        href={href}
      />
    </>
  )
}
